import React from 'react'
import ReactDOM from 'react-dom'
import '../App.css';

export default function Modal(props) {
    const [opens, setOpens] = props.open
    let [a,b] = props.foodData
    return ReactDOM.createPortal(
        <>
            <div className="modal-container">
                <div className="modal-frame">
                    <button className="close-btn" onClick = {() => setOpens(!opens)}> X </button>
                    <div className="modal-info">
                        <h1 style = {{textDecoration: 'underline'}}> Resources</h1>
                        <div className="modal-text">
                            <h2> Recipe Blog </h2>
                            <a href = {a !== null && a}> Recipe Blog Link </a>
                            <br/>
                            <h2> Ingredient List </h2>
                            <li> {b !== null && b.map((ingr) => {
                                return(
                                    <li>
                                        -{ingr}
                                    </li>
                                )
                            })} </li>

                        </div>
                    </div>
                </div>
            </div>
        </>,
        document.getElementById('react-modal-2')
    )
}
